module.exports = __webpack_public_path__ + "media/home/5lb-bag-2ca6a944.png";